<template>
  <transition
    name="card"
    mode="out-in"
    appear
  >
    <li
      class="filter--card decors-background-carrousel"
      :style="`--delay: ${index*150}ms;`"
      :class="[{ selected }, filterType]"
      @click="$emit('selected', filter.value)"
    >
      <div class="filter--card__counter">
        <span>{{ index+1 }}</span>
        <svg
          width="18"
          height="16"
          viewBox="0 0 18 16"
        >
          <path
            d="M1 1L17 15"
            stroke="white"
            stroke-miterlimit="10"
          />
        </svg>
        <span>{{ filterValues.length }}</span>
      </div>
      <div
        v-if="filterType === 'value'"
        class="filter--card__tails"
        :class="`coin-product-revers-${filter.value}`"
      />
      <div
        class="filter--card__head"
        :class="`${head}`"
      />
      <div class="filter--card__label">
        <strong>{{ processPluralString(filter.label, filter.count) }}</strong>
        {{ processPluralString(filter.notice, filter.count) }}
      </div>
      <div class="filter--card__arrow decors-background-carrousel-coin-gauche">
        <BackToTop class="filter--card__arrow__icon" />
      </div>
    </li>
  </transition>
</template>
<script>
import BackToTop from '@/assets/images/decors/icons/back-to-top.svg?inline';
import mixin from '@/components/common/filter/FilterMixin.vue';

export default {
  name: 'FilterValueCard',
  components: {
    BackToTop,
  },
  mixins: [mixin],
  props: {
    filter: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  computed: {
    head() {
      return `coin-menu-${this.filterType}-vague${this.$currentWave}-${this.filter.value}`;
    },
  },
};
</script>
<style lang="stylus" scoped>
.filter--card {
  aspect-ratio: 241 / 333;
  width: var(--carousel-item-width);
  height: auto;
  position: relative;
  cursor: pointer;
  transition: filter 0.3s;
  flex-shrink: 0;

  +vue-transition("card", 350ms, ease-out, var(--delay, 0)) {
    transform: translateY(-20px) translateZ(30px);
    opacity: 0;
  }


  &__head {
    margin: 30px auto 0;
    position: relative;
    transition: transform 0.3s ease-out;
    .filter--card.collection & {
      margin: 50px auto 0;
    }
  }
  &__tails {
    position: absolute;
    right: 10px;
    bottom: 40px;
    transition: transform 0.3s ease-out;
  }
  &__counter {
    position: absolute;
    display: flex;
    flex-direction: column;
    top: 0;
    left: 0;
    color: var(--white, #FFF);
    font-size: 18px;
    padding: 10px;
    text-align: left;
    gap: -5px;

    span:first-child {
      font-weight: 700;
      padding-left: 11px;
    }
    svg {
      margin-top: -6px
    }
    span:last-child {
      margin-top: -6px
      padding-left: 2px;
    }
  }
  &__label {
    border-radius: 3px;
    background: rgba(0, 0, 0, 0.90);
    width: fit-content;
    position: absolute;
    bottom: 10px;
    left: 61px;
    text-align: left;
    padding: 3px 10px
    color: var(--white, #FFF);
    font-size: 20px;
    font-style: normal;
    line-height: 22px;
    text-transform: uppercase;
    z-index: 2;
    transition: transform 0.3s ease-out;
    strong {
      display: block;
    }
  }

  &__arrow {
    position: absolute
    bottom: 5px
    left: 5px;
    z-index: 0;

    &__icon {
      transform: rotate(90deg);
      position: absolute
      bottom: 10px;
      left: 10px;
      transition: transform 0.3s ease-out;
    }
  }


  &:not(.selected) {
    filter: brightness(0.7);
  }

  &.selected, &:hover {
    filter: brightness(1);

    & {
      .filter--card__arrow {
        .filter--card__arrow__icon {
          transform: rotate(180deg);
        }
      }
    }
    .filter--card__head {
      transform: translate(-5px, -5px)
    }
    .filter--card__tails {
      transform: translate(2px, 2px)
    }
    .filter--card__label {
      transform: translateY(-5px)
    }
  }
}
</style>
